import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
} from "@mui/material";
import useUpdate from "../../../../api/useUpdate";
import useFetchObjects from "../../../../api/useFetchObjects";

const EditDentalTreatmentDetail = ({
  open,
  onClose,
  detail,
  refetch,
  token,
}) => {
  console.log(detail);
  const [formData, setFormData] = useState({
    procedure: detail.procedure || "",
    tooth_number: detail.tooth_number || "",
    cost: detail.cost || "",
  });

  const { data } = useFetchObjects(
    ["dental-procedure"],
    `dental-procedure/`,
    token,
  );
  const { handleUpdate } = useUpdate("detail-treatment-details", token);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const updatedData = new FormData();
    updatedData.append("procedure", formData.procedure);
    updatedData.append("tooth_number", formData.tooth_number);
    updatedData.append("cost", formData.cost);

    handleUpdate(detail.id, updatedData);
    refetch();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Edit Treatment Detail</DialogTitle>
      <DialogContent>
        <TextField
          select
          fullWidth
          margin="dense"
          label="Procedure"
          name="procedure"
          value={formData.procedure}
          onChange={handleChange}
        >
          {data &&
            data.map((item, index) => (
              <MenuItem value={item.id} key={index}>
                {item.name}
              </MenuItem>
            ))}
        </TextField>
        <TextField
          fullWidth
          margin="dense"
          label="Tooth Number"
          name="tooth_number"
          value={formData.tooth_number}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="dense"
          label="Cost"
          name="cost"
          value={formData.cost}
          onChange={handleChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditDentalTreatmentDetail;
